// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductOption_title__3A37B","table":"ProductOption_table__3TZTb"};